// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__1Wll9","spinner":"Loading_spinner__oo0mv","spin":"Loading_spin__MVryE"};